<script setup lang="ts">
import type { ProductInformation, ProductsList } from "~/models/Content/ContentProducts"
import { keys } from "~/utilities/injection"

const props = defineProps<{ product: ProductsList }>()

const emit = defineEmits(["close"])

const showVariantModal = inject(keys.showVariantModal)

function getVariantPath(variant: ProductInformation) {
  const path = `/produkter/${props.product.productKey}/${variant.variantKey}`

  const query = !variant.userHasLicence
    ? { "til-gratis-kapittel": "true" }
    : undefined
  return { path, query }
}
</script>

<template>
  <div>
    <UModal v-model="showVariantModal" @close="emit('close')">
      <template #header>
        <h1 class="font-national2condensed text-6xl font-medium leading-none text-dark-blue-80">
          Hvor studerer du?
        </h1>
      </template>
      <div class="flex flex-col gap-2">
        <UButton
          v-for="variant in product?.variants.filter(
            v => v.isReleased,
          )"
          :key="variant.shortVariantLabel"
          class="mb-2"
          size="md"
          theme="cta"
          :to="getVariantPath(variant)"
        >
          {{ variant.curriculumFor.replaceAll(" og ", " eller ") }}
        </UButton>
      </div>
      Finner du ikke ditt studiested?
      <UContactCustomerService />.
    </UModal>
  </div>
</template>
